import { Progress, Form } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import StepWizard from 'react-step-wizard';
import IconBack from '../../../assets/Images/icons/icon-back';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import DCDPOService from '../../../services/DCDPO.service';
import { useBlocker } from '../../../util/usePrompt';
import GlobalService from '../../../services/Global.service';
import RecruitmentPolicyService from '../../../services/RecruitmentPolicy.service';
import Step1 from './component/Step1';
import Step2 from './component/Step2';
import Step3 from './component/Step3';
import Step4 from './component/Step4';
import Step5 from './component/Step5';
import Step6 from './component/Step6';
import Step7 from './component/Step7';
import Step8 from './component/Step8';
import StepList from './component/StepList';
import StepPreview from './component/StepPreview';
import { POLICY_NAME } from '../POLICY';

const { Provider } = Form;

export default function RecruitmentDetail() {
    const { t, i18n } = useTranslation(['translation', 'hr-policy']);
    const lang = i18n.language;
    let navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const notify = useNotify();

    const [data] = useState([
        { name: 'Define the policy name and organization information', key: 1 },
        { name: 'Introduction and Lawful Basis', key: 2 },
        { name: 'Personal Data Collected and Source', key: 3 },
        { name: 'Reason for collected data', key: 4 },
        { name: 'Who we will disclose or transfer personal data', key: 5 },
        { name: 'How long and how we retain personal data?', key: 6 },
        { name: 'Data Subject Rights', key: 7 },
        { name: 'Policy change and contact channels', key: 8 },
    ]);

    const [state, updateState] = useState();
    const [applications, setApplications] = useState([]);

    const [currentSelectList, setCurrentSelectList] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading_, setLoadingSave] = useState(false);
    const [loadingDraft_, setLoadingDraft] = useState(false);
    const [fixed, setFixed] = useState(false);
    const [editData, setEditData] = useState();
    const editMode = false;
    const [dsType, setDsType] = useState([]);

    // check validations
    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [step6, setStep6] = useState(false);
    const [step7, setStep7] = useState(false);
    const [step8, setStep8] = useState(false);

    // form
    const [recruitmentPrivacyPolicy] = Form.useForm();
    const [recruitmentIntroductionLawfulBasis] = Form.useForm();
    const [recruitmentPersonalDataCollect] = Form.useForm();
    const [recruitmentReasonCollectedData] = Form.useForm();
    const [recruitmentTransferPersonalData] = Form.useForm();
    const [recruitmentRetainPersonalData] = Form.useForm();
    const [recruitmentDataSubjectRight] = Form.useForm();
    const [recruitmentPolicyChange] = Form.useForm();
    const [preview] = Form.useForm();

    const [submitData, setSubmitData] = useState();

    //Discard change
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const onFormChange = (_, info) => {
        if (info.changedFields.length > 0) {
            setChange(true);
        }
    };

    const onFormFinish = async (name, info) => {
        const values = info?.values;
        const dsTypeList = [];
        recruitmentPrivacyPolicy
            ?.getFieldValue('recruitmentPrivacyPolicyDataSubjectType')
            ?.forEach((val) => {
                const item = dsType?.filter((res) => res?.value === val)[0];
                const privacyId =
                    editData?.recruitmentPrivacyPolicy?.recruitmentPrivacyPolicyDataSubjectType?.find(
                        (res) => res?.recruitmentDataSubjectId === val
                    )?.recruitmentDataSubjectId;
                dsTypeList?.push({
                    recruitmentPrivacyPolicyDataSubjectTypeId: privacyId,
                    recruitmentDataSubjectId: item?.value,
                    recruitmentDataSubjectNameTh: item?.title,
                    recruitmentDataSubjectNameEn: item?.title,
                });
            });
        const form = {
            recruitmentPrivacyPolicy: {
                ...recruitmentPrivacyPolicy?.getFieldsValue(),
                recruitmentPrivacyPolicyId: id === 'new' ? undefined : id,
                recruitmentPrivacyPolicyDataSubjectType: dsTypeList,
                recruitmentEffectiveDate:
                    recruitmentPrivacyPolicy?.getFieldValue(
                        'recruitmentEffectiveDate'
                    )
                        ? recruitmentPrivacyPolicy
                              ?.getFieldValue('recruitmentEffectiveDate')
                              ?.format('YYYY-MM-DDT00:00:00.000+00:00')
                        : '',
                isPublish: true,
            },
            recruitmentIntroductionLawfulBasis: {
                ...recruitmentIntroductionLawfulBasis?.getFieldsValue(),
                recruitmentIntroductionLawfulBasisId:
                    editData?.recruitmentIntroductionLawfulBasis
                        ?.recruitmentIntroductionLawfulBasisId,
                recruitmentIntroductionIsDisplay:
                    values?.recruitmentIntroductionIsDisplay,
                recruitmentLawfulBasisIsDisplay:
                    values?.recruitmentLawfulBasisIsDisplay,
            },
            recruitmentPersonalDataCollect: {
                ...recruitmentPersonalDataCollect?.getFieldsValue(),
                recruitmentPersonalDataCollectId:
                    editData?.recruitmentPersonalDataCollect
                        ?.recruitmentPersonalDataCollectId,
                recruitmentPersonalDataIsDisplay:
                    values?.recruitmentPersonalDataIsDisplay,
                recruitmentSourceIsDisplay: values?.recruitmentSourceIsDisplay,
            },
            recruitmentReasonCollectedData: {
                ...recruitmentReasonCollectedData?.getFieldsValue(),
                recruitmentReasonCollectedDataId:
                    editData?.recruitmentReasonCollectedData
                        ?.recruitmentReasonCollectedDataId,
                recruitmentPurposeIsDisplay:
                    values?.recruitmentPurposeIsDisplay,
            },
            recruitmentTransferPersonalData: {
                ...recruitmentTransferPersonalData?.getFieldsValue(),
                recruitmentTransferPersonalDataId:
                    editData?.recruitmentTransferPersonalData
                        ?.recruitmentReasonCollectedDataId,
                recruitmentDisclosureIsDisplay:
                    values?.recruitmentDisclosureIsDisplay,
                recruitmentInternationalIsDisplay:
                    values?.recruitmentInternationalIsDisplay,
            },
            recruitmentRetainPersonalData: {
                ...recruitmentRetainPersonalData?.getFieldsValue(),
                recruitmentRetainPersonalDataId:
                    editData?.recruitmentRetainPersonalData
                        ?.recruitmentRetainPersonalDataId,
                recruitmentRetentionIsDisplay:
                    values?.recruitmentRetentionIsDisplay,
                recruitmentSecurityIsDisplay:
                    values?.recruitmentSecurityIsDisplay,
            },
            recruitmentDataSubjectRight: {
                ...recruitmentDataSubjectRight?.getFieldsValue(),
                recruitmentDataSubjectRightId:
                    editData?.recruitmentDataSubjectRight
                        ?.recruitmentDataSubjectRightId,
                recruitmentDataSubjectRightIsDisplay:
                    values?.recruitmentDataSubjectRightIsDisplay,
            },
            recruitmentPolicyChange: {
                ...recruitmentPolicyChange?.getFieldsValue(),
                recruitmentPolicyChangeId:
                    editData?.recruitmentPolicyChange
                        ?.recruitmentPolicyChangeId,
                recruitmentChangeIsDisplay: values?.recruitmentChangeIsDisplay,
                recruitmentDataControllerIsDisplay:
                    values?.recruitmentDataControllerIsDisplay,
                recruitmentDataProtectionIsDisplay:
                    values?.recruitmentDataProtectionIsDisplay,
            },
        };
        try {
            setChange(false);
            setOpenChange(false);
            setLoadingSave(true);
            const { data } =
                await RecruitmentPolicyService.saveRecruitmentPolicy(form);
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                navigate(
                    `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.RECRUITMENT_POLICY}`
                );
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedSaveData'),
            });
        }
    };

    useEffect(() => {
        const current = location.hash.replace('#step', '');
        if (current) {
            setCurrentSelectList(Number(current));
        }
        if (current === '9') {
            setFixed(false);
        }
    }, [location]);

    const setInstance = (SW) =>
        updateState({
            ...state,
            SW,
        });
    const passStep =
        step1 & step2 & step3 & step4 & step5 & step6 & step7 & step8;
    const filter = [
        step1,
        step2,
        step3,
        step4,
        step5,
        step6,
        step7,
        step8,
    ].filter(Boolean).length;
    const currentProgress = ((filter * 100) / 8).toFixed(0);

    const getRecruitmentDetail = async (id) => {
        try {
            setLoading(true);
            const { data } =
                await RecruitmentPolicyService.getRecruitmentPolicyDetail(id);
            const res = data?.resultData;
            const dateItem =
                res?.recruitmentPrivacyPolicy?.effectiveDate?.split(' ');
            const day = dateItem[0]?.split('/')[0];
            const month = dateItem[0]?.split('/')[1];
            const year = dateItem[0]?.split('/')[2];
            const effDate = new Date(
                `${year}-${month}-${day}T${dateItem[1]}:00.000Z`
            );
            setEditData({
                recruitmentPrivacyPolicy: {
                    ...res?.recruitmentPrivacyPolicy,
                    recruitmentEffectiveDate: res?.recruitmentPrivacyPolicy
                        ?.effectiveDate
                        ? moment(effDate)
                        : null,
                },
                recruitmentIntroductionLawfulBasis: {
                    ...res?.recruitmentIntroductionLawfulBasis,
                },
                recruitmentPersonalDataCollect: {
                    ...res?.recruitmentPersonalDataCollect,
                },
                recruitmentReasonCollectedData: {
                    ...res?.recruitmentReasonCollectedData,
                },
                recruitmentTransferPersonalData: {
                    ...res?.recruitmentTransferPersonalData,
                },
                recruitmentRetainPersonalData: {
                    ...res?.recruitmentRetainPersonalData,
                },
                recruitmentDataSubjectRight: {
                    ...res?.recruitmentDataSubjectRight,
                },
                recruitmentPolicyChange: {
                    ...res?.recruitmentPolicyChange,
                },
            });
            const dsTypeId = [];
            res?.recruitmentPrivacyPolicy?.recruitmentPrivacyPolicyDataSubjectType?.forEach(
                (val) => {
                    dsTypeId?.push(val?.recruitmentDataSubjectId);
                }
            );
            recruitmentDataSubjectRight?.setFieldsValue({
                ...res?.recruitmentDataSubjectRight,
            });
            recruitmentIntroductionLawfulBasis?.setFieldsValue({
                ...res?.recruitmentIntroductionLawfulBasis,
            });
            recruitmentPersonalDataCollect?.setFieldsValue({
                ...res?.recruitmentPersonalDataCollect,
            });
            recruitmentPolicyChange?.setFieldsValue({
                ...res?.recruitmentPolicyChange,
            });
            recruitmentPrivacyPolicy?.setFieldsValue({
                ...res?.recruitmentPrivacyPolicy,
                recruitmentPrivacyPolicyDataSubjectType: dsTypeId,
                recruitmentEffectiveDate: res?.recruitmentPrivacyPolicy
                    ?.effectiveDate
                    ? moment(effDate)
                    : null,
            });
            recruitmentReasonCollectedData?.setFieldsValue({
                ...res?.recruitmentReasonCollectedData,
            });
            recruitmentRetainPersonalData?.setFieldsValue({
                ...res?.recruitmentRetainPersonalData,
            });
            recruitmentTransferPersonalData?.setFieldsValue({
                ...res?.recruitmentTransferPersonalData,
            });
            preview?.setFieldsValue({
                recruitmentChangeIsDisplay:
                    res?.recruitmentPolicyChange?.recruitmentChangeIsDisplay,
                recruitmentDataControllerIsDisplay:
                    res?.recruitmentPolicyChange
                        ?.recruitmentDataControllerIsDisplay,
                recruitmentDataProtectionIsDisplay:
                    res?.recruitmentPolicyChange
                        ?.recruitmentDataProtectionIsDisplay,
                recruitmentDataSubjectRightIsDisplay:
                    res?.recruitmentDataSubjectRight
                        ?.recruitmentDataSubjectRightIsDisplay,
                recruitmentDisclosureIsDisplay:
                    res?.recruitmentTransferPersonalData
                        ?.recruitmentDisclosureIsDisplay,
                recruitmentInternationalIsDisplay:
                    res?.recruitmentTransferPersonalData
                        ?.recruitmentInternationalIsDisplay,
                recruitmentIntroductionIsDisplay:
                    res?.recruitmentIntroductionLawfulBasis
                        ?.recruitmentIntroductionIsDisplay,
                recruitmentLawfulBasisIsDisplay:
                    res?.recruitmentIntroductionLawfulBasis
                        ?.recruitmentLawfulBasisIsDisplay,
                recruitmentPersonalDataIsDisplay:
                    res?.recruitmentPersonalDataCollect
                        ?.recruitmentPersonalDataIsDisplay,
                recruitmentPurposeIsDisplay:
                    res?.recruitmentReasonCollectedData
                        ?.recruitmentPurposeIsDisplay,
                recruitmentRetentionIsDisplay:
                    res?.recruitmentRetainPersonalData
                        ?.recruitmentRetentionIsDisplay,
                recruitmentSecurityIsDisplay:
                    res?.recruitmentRetainPersonalData
                        ?.recruitmentSecurityIsDisplay,
                recruitmentSourceIsDisplay:
                    res?.recruitmentPersonalDataCollect
                        ?.recruitmentSourceIsDisplay,
            });
            setSubmitData({
                recruitmentPrivacyPolicy: {
                    ...res?.recruitmentPrivacyPolicy,
                    recruitmentEffectiveDate:
                        res?.recruitmentPrivacyPolicy?.effectiveDate?.split(
                            ' '
                        )[0],
                },
                recruitmentIntroductionLawfulBasis: {
                    ...res?.recruitmentIntroductionLawfulBasis,
                },
                recruitmentPersonalDataCollect: {
                    ...res?.recruitmentPersonalDataCollect,
                },
                recruitmentReasonCollectedData: {
                    ...res?.recruitmentReasonCollectedData,
                },
                recruitmentTransferPersonalData: {
                    ...res?.recruitmentTransferPersonalData,
                },
                recruitmentRetainPersonalData: {
                    ...res?.recruitmentRetainPersonalData,
                },
                recruitmentDataSubjectRight: {
                    ...res?.recruitmentDataSubjectRight,
                },
                recruitmentPolicyChange: {
                    ...res?.recruitmentPolicyChange,
                },
            });
            setOpenChange(false);
            setChange(false);
            setLoading(false);
        } catch (error) {
            console.log(error);
        }
    };

    const getDsTypeDropdown = async () => {
        try {
            const { data } = await GlobalService.getDs();
            if (data?.resultData) {
                let option = [];
                data?.resultData?.dataSubjectType?.forEach((element) => {
                    option.push({
                        title: lang === 'en' ? element.nameEn : element?.nameTh,
                        value: element?.id,
                    });
                });
                setDsType(option);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getDsTypeDropdown();
        if (id !== 'new') getRecruitmentDetail(id);
        else getDCDPO();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const getDCDPO = async () => {
        try {
            const { data } = await DCDPOService.getDCDPO();
            const item = data?.resultData;
            if (item) {
                recruitmentPolicyChange.setFieldsValue({
                    recruitmentDataControllerContentTh: `${item?.nameDPOTh}</br>${item?.addressTh}`,
                    recruitmentDataControllerContentEn: `${item?.nameDPOEn}</br>${item?.addressEn}`,
                    recruitmentDataProtectionContentTh: `${item?.staffNameDPOTh}`,
                    recruitmentDataProtectionContentEn: `${item?.staffNameDPOTh}`,
                });
                setChange(false);
                setOpenChange(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const saveDraft = async () => {
        try {
            const display = preview?.getFieldsValue();
            const dsTypeList = [];
            recruitmentPrivacyPolicy
                ?.getFieldValue('recruitmentPrivacyPolicyDataSubjectType')
                ?.forEach((val) => {
                    const item = dsType?.filter((res) => res?.value === val)[0];
                    const privacyId =
                        editData?.recruitmentPrivacyPolicy?.recruitmentPrivacyPolicyDataSubjectType?.find(
                            (res) => res?.recruitmentDataSubjectId === val
                        )?.recruitmentDataSubjectId;
                    dsTypeList?.push({
                        recruitmentPrivacyPolicyDataSubjectTypeId: privacyId,
                        recruitmentDataSubjectId: item?.value,
                        recruitmentDataSubjectNameTh: item?.title,
                        recruitmentDataSubjectNameEn: item?.title,
                    });
                });
            const form = {
                recruitmentPrivacyPolicy: {
                    ...recruitmentPrivacyPolicy?.getFieldsValue(),
                    recruitmentPrivacyPolicyId: id === 'new' ? undefined : id,
                    recruitmentPrivacyPolicyDataSubjectType: dsTypeList,
                    recruitmentEffectiveDate:
                        recruitmentPrivacyPolicy?.getFieldValue(
                            'recruitmentEffectiveDate'
                        )
                            ? recruitmentPrivacyPolicy
                                  ?.getFieldValue('recruitmentEffectiveDate')
                                  ?.format('YYYY-MM-DDT00:00:00.000+00:00')
                            : '',
                    isPublish: false,
                },
                recruitmentIntroductionLawfulBasis: {
                    ...recruitmentIntroductionLawfulBasis?.getFieldsValue(),
                    recruitmentIntroductionLawfulBasisId:
                        editData?.recruitmentIntroductionLawfulBasis
                            ?.recruitmentIntroductionLawfulBasisId,
                    recruitmentIntroductionIsDisplay:
                        display?.recruitmentIntroductionIsDisplay,
                    recruitmentLawfulBasisIsDisplay:
                        display?.recruitmentLawfulBasisIsDisplay,
                },
                recruitmentPersonalDataCollect: {
                    ...recruitmentPersonalDataCollect?.getFieldsValue(),
                    recruitmentPersonalDataCollectId:
                        editData?.recruitmentPersonalDataCollect
                            ?.recruitmentPersonalDataCollectId,
                    recruitmentPersonalDataIsDisplay:
                        display?.recruitmentPersonalDataIsDisplay,
                    recruitmentSourceIsDisplay:
                        display?.recruitmentSourceIsDisplay,
                },
                recruitmentReasonCollectedData: {
                    ...recruitmentReasonCollectedData?.getFieldsValue(),
                    recruitmentReasonCollectedDataId:
                        editData?.recruitmentReasonCollectedData
                            ?.recruitmentReasonCollectedDataId,
                    recruitmentPurposeIsDisplay:
                        display?.recruitmentPurposeIsDisplay,
                },
                recruitmentTransferPersonalData: {
                    ...recruitmentTransferPersonalData?.getFieldsValue(),
                    recruitmentTransferPersonalDataId:
                        editData?.recruitmentTransferPersonalData
                            ?.recruitmentReasonCollectedDataId,
                    recruitmentDisclosureIsDisplay:
                        display?.recruitmentDisclosureIsDisplay,
                    recruitmentInternationalIsDisplay:
                        display?.recruitmentInternationalIsDisplay,
                },
                recruitmentRetainPersonalData: {
                    ...recruitmentRetainPersonalData?.getFieldsValue(),
                    recruitmentRetainPersonalDataId:
                        editData?.recruitmentRetainPersonalData
                            ?.recruitmentRetainPersonalDataId,
                    recruitmentRetentionIsDisplay:
                        display?.recruitmentRetentionIsDisplay,
                    recruitmentSecurityIsDisplay:
                        display?.recruitmentSecurityIsDisplay,
                },
                recruitmentDataSubjectRight: {
                    ...recruitmentDataSubjectRight?.getFieldsValue(),
                    recruitmentDataSubjectRightId:
                        editData?.recruitmentDataSubjectRight
                            ?.recruitmentDataSubjectRightId,
                    recruitmentDataSubjectRightIsDisplay:
                        display?.recruitmentDataSubjectRightIsDisplay,
                },
                recruitmentPolicyChange: {
                    ...recruitmentPolicyChange?.getFieldsValue(),
                    recruitmentPolicyChangeId:
                        editData?.recruitmentPolicyChange
                            ?.recruitmentPolicyChangeId,
                    recruitmentChangeIsDisplay:
                        display?.recruitmentChangeIsDisplay,
                    recruitmentDataControllerIsDisplay:
                        display?.recruitmentDataControllerIsDisplay,
                    recruitmentDataProtectionIsDisplay:
                        display?.recruitmentDataProtectionIsDisplay,
                },
            };
            setChange(false);
            setOpenChange(false);
            setLoadingDraft(true);
            const { data } =
                await RecruitmentPolicyService.saveRecruitmentPolicy(form);
            if (data?.resultCode === 1) {
                setLoadingDraft(false);
                await notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                const recruitmentPolicyId =
                    data?.resultData?.recruitmentPrivacyPolicyId;
                const fullPath = window.location.href;
                const step = fullPath?.split('#')[1];
                await getRecruitmentDetail(recruitmentPolicyId);
                await navigate(
                    ROUTER?.POLICY?.RECRUITMENT_PRIVACY +
                        `/${recruitmentPolicyId}#${step}`
                );
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        } catch (error) {
            console.log(error);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedSaveData'),
            });
        }
    };

    const calProgress = () => {
        const dsTypeList = [];
        recruitmentPrivacyPolicy
            ?.getFieldValue('recruitmentPrivacyPolicyDataSubjectType')
            ?.forEach((val) => {
                const item = dsType?.filter((res) => res?.value === val)[0];
                dsTypeList?.push({
                    recruitmentPrivacyPolicyDataSubjectTypeId:
                        editData?.recruitmentPrivacyPolicyDataSubjectTypeId,
                    recruitmentDataSubjectId: item?.value,
                    recruitmentDataSubjectNameTh: item?.title,
                    recruitmentDataSubjectNameEn: item?.title,
                });
            });
        const display = preview?.getFieldsValue();
        setSubmitData({
            recruitmentPrivacyPolicy: {
                ...submitData?.recruitmentPrivacyPolicy,
                ...recruitmentPrivacyPolicy?.getFieldsValue(),
                recruitmentPrivacyPolicyId:
                    editData?.recruitmentPrivacyPolicyId,
                recruitmentPrivacyPolicyDataSubjectType: dsTypeList,
                recruitmentEffectiveDate: recruitmentPrivacyPolicy
                    ?.getFieldValue('recruitmentEffectiveDate')
                    ?.format('DD/MM/YYYY'),
                isPublish: false,
            },
            recruitmentIntroductionLawfulBasis: {
                ...submitData?.recruitmentIntroductionLawfulBasis,
                ...recruitmentIntroductionLawfulBasis?.getFieldsValue(),
                recruitmentIntroductionLawfulBasisId:
                    editData?.recruitmentIntroductionLawfulBasisId,
                recruitmentIntroductionIsDisplay:
                    display?.recruitmentIntroductionIsDisplay,
                recruitmentLawfulBasisIsDisplay:
                    display?.recruitmentLawfulBasisIsDisplay,
            },
            recruitmentPersonalDataCollect: {
                ...submitData?.recruitmentPersonalDataCollect,
                ...recruitmentPersonalDataCollect?.getFieldsValue(),
                recruitmentPersonalDataCollectId:
                    editData?.recruitmentPersonalDataCollectId,
                recruitmentPersonalDataIsDisplay:
                    display?.recruitmentPersonalDataIsDisplay,
                recruitmentSourceIsDisplay: display?.recruitmentSourceIsDisplay,
            },
            recruitmentReasonCollectedData: {
                ...submitData?.recruitmentReasonCollectedData,
                ...recruitmentReasonCollectedData?.getFieldsValue(),
                recruitmentReasonCollectedDataId:
                    editData?.recruitmentReasonCollectedDataId,
                recruitmentPurposeIsDisplay:
                    display?.recruitmentPurposeIsDisplay,
            },
            recruitmentTransferPersonalData: {
                ...submitData?.recruitmentTransferPersonalData,
                ...recruitmentTransferPersonalData?.getFieldsValue(),
                recruitmentTransferPersonalDataId:
                    editData?.recruitmentReasonCollectedDataId,
                recruitmentDisclosureIsDisplay:
                    display?.recruitmentDisclosureIsDisplay,
                recruitmentInternationalIsDisplay:
                    display?.recruitmentInternationalIsDisplay,
            },
            recruitmentRetainPersonalData: {
                ...submitData?.recruitmentRetainPersonalData,
                ...recruitmentRetainPersonalData?.getFieldsValue(),
                recruitmentRetainPersonalDataId:
                    editData?.recruitmentRetainPersonalDataId,
                recruitmentRetentionIsDisplay:
                    display?.recruitmentRetentionIsDisplay,
                recruitmentSecurityIsDisplay:
                    display?.recruitmentSecurityIsDisplay,
            },
            recruitmentDataSubjectRight: {
                ...submitData?.recruitmentDataSubjectRight,
                ...recruitmentDataSubjectRight?.getFieldsValue(),
                recruitmentDataSubjectRightId:
                    editData?.recruitmentDataSubjectRightId,
                recruitmentDataSubjectRightIsDisplay:
                    display?.recruitmentDataSubjectRightIsDisplay,
            },
            recruitmentPolicyChange: {
                ...submitData?.recruitmentPolicyChange,
                ...recruitmentPolicyChange?.getFieldsValue(),
                recruitmentPolicyChangeId: editData?.recruitmentPolicyChangeId,
                recruitmentChangeIsDisplay: display?.recruitmentChangeIsDisplay,
                recruitmentDataControllerIsDisplay:
                    display?.recruitmentDataControllerIsDisplay,
                recruitmentDataProtectionIsDisplay:
                    display?.recruitmentDataProtectionIsDisplay,
            },
        });
        if (!editMode) {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <div className="title flex items-center">
                <div
                    className="cursor-pointer mr-3 space-x-2"
                    onClick={() => {
                        navigate(
                            `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.RECRUITMENT_POLICY}`
                        );
                        // ${PRIVACY_NAME_BY_ID[_tab.policyTypeId]}
                    }}
                >
                    <IconBack />
                    <span>
                        {id === 'new'
                            ? t('Add Recruitment Privacy Policy', {
                                  ns: 'hr-policy',
                              })
                            : t('Edit Recruitment Privacy Policy', {
                                  ns: 'hr-policy',
                              })}
                    </span>
                </div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Privacy')} / {t('Recruitment Privacy Policy')} /{' '}
                </span>
                <span>
                    {id === 'new'
                        ? t('Add Recruitment Privacy Policy', {
                              ns: 'hr-policy',
                          })
                        : t('Edit Recruitment Privacy Policy', {
                              ns: 'hr-policy',
                          })}
                </span>
            </div>
            <div className="mt-4 grid grid-cols-4 gap-4">
                {currentSelectList !== 9 && (
                    <StepList
                        steps={{
                            step1,
                            step2,
                            step3,
                            step4,
                            step5,
                            step6,
                            step7,
                            step8,
                        }}
                        setCurrentSelectList={() => {
                            // cannot move sp5
                        }}
                        SW={state?.SW}
                        currentSelectList={currentSelectList}
                        data={data}
                        setFixed={setFixed}
                    />
                )}
                <div
                    className={classNames({
                        'col-span-3': currentSelectList !== 9,
                        'col-span-4': currentSelectList === 9,
                    })}
                >
                    {currentSelectList !== 9 && (
                        <div className="bg-white rounded-md p-4 flex font-semibold text-base">
                            <div className="flex-1 -mt-0.5">
                                <Progress
                                    strokeColor={{
                                        '0%': '#4ACE8F',
                                        '100%': '#4ACE8F',
                                    }}
                                    percent={currentProgress}
                                    status="active"
                                    showInfo={false}
                                />
                            </div>
                            <span
                                className={`pl-6 pr-2 ${
                                    currentProgress === 0
                                        ? 'text-red-500'
                                        : 'text-green-400'
                                }`}
                            >
                                {currentProgress}% {t('succeed')}
                            </span>

                            <span>{t('filledinformation')}</span>
                        </div>
                    )}
                    <Provider
                        onFormChange={onFormChange}
                        onFormFinish={onFormFinish}
                    >
                        <div className="mt-4 bg-white rounded-md p-4 overflow-hidden">
                            <StepWizard
                                isHashEnabled
                                instance={setInstance}
                                onStepChange={(e) => {
                                    setCurrentSelectList(e.activeStep);
                                }}
                            >
                                <Step1
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={recruitmentPrivacyPolicy}
                                    calProgress={calProgress}
                                    setStep1={setStep1}
                                    step1={step1}
                                    editData={editData}
                                    dsType={dsType}
                                />
                                <Step2
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={recruitmentIntroductionLawfulBasis}
                                    calProgress={calProgress}
                                    setStep2={setStep2}
                                    step2={step2}
                                    editData={editData}
                                />
                                <Step3
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={recruitmentPersonalDataCollect}
                                    calProgress={calProgress}
                                    setStep3={setStep3}
                                    step3={step3}
                                    editData={editData}
                                />
                                <Step4
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={recruitmentReasonCollectedData}
                                    calProgress={calProgress}
                                    setStep4={setStep4}
                                    step4={step4}
                                    editData={editData}
                                />
                                <Step5
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={recruitmentTransferPersonalData}
                                    calProgress={calProgress}
                                    setStep5={setStep5}
                                    step5={step5}
                                    editData={editData}
                                />
                                <Step6
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={recruitmentRetainPersonalData}
                                    calProgress={calProgress}
                                    setStep6={setStep6}
                                    step6={step6}
                                    editData={editData}
                                />
                                <Step7
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={recruitmentDataSubjectRight}
                                    calProgress={calProgress}
                                    setStep7={setStep7}
                                    step7={step7}
                                    editData={editData}
                                />
                                <Step8
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    form={recruitmentPolicyChange}
                                    calProgress={calProgress}
                                    passStep={passStep}
                                    setStep8={setStep8}
                                    step8={step8}
                                    editData={editData}
                                />
                                <StepPreview
                                    saveDraft={saveDraft}
                                    form={preview}
                                    loading_={loading_}
                                    loadingDraft_={loadingDraft_}
                                    loading={loading}
                                    applications={applications}
                                    data={submitData}
                                    calProgress={calProgress}
                                    privacyNoticeId={id}
                                    editData={editData}
                                    onFormFinish={onFormFinish}
                                />
                            </StepWizard>
                        </div>
                    </Provider>
                </div>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
        </Fragment>
    );
}
